import moment from 'moment';

export const DISPLAY_FORMAT = 'DD.MM.YYYY';
export const formatDate = (inp) =>  moment(inp).format(DISPLAY_FORMAT);


export const DISPLAY_DATE_TIME_FORMAT = 'DD.MM.YYYY. HH:mm';
export const formatDateTime = (inp) =>  moment(inp).format(DISPLAY_DATE_TIME_FORMAT);

export const verboseDate = (inp) =>  moment(inp).format("LL");


// WEBPACK FOOTER //
// ./src/utils/date.js